<template>
    <div class="comprehensiveconditions">
        <div class="header">
            <div class="item">{{$t('original.languages552')}}<el-input v-model="params.condition" clearable :placeholder="$t('original.languages553')" style="width:240px;"></el-input></div>
            <el-button type="primary" @click="search">{{$t('original.languages470')}}</el-button>
            <el-button  @click="reset">{{$t('original.reset')}}</el-button>
        </div>
        <div class="Main">
            <el-button type="primary" style="margin-bottom: 20px;" @click="$router.push('Addconditions')">{{$t('original.languages288')}}</el-button>
            <el-table
            v-loading="loading"
            :data="comprehensiveData"
            >
            <el-table-column :label="$t('original.The_serial_number')" width="70px">
                <template slot-scope="scope" center>
                {{ (params.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>    
            <el-table-column prop="conditionname" :label="$t('original.languages554')"></el-table-column>
            <el-table-column prop="condition" :label="$t('original.languages555')" width="500px"></el-table-column>

            <el-table-column prop="isActive" :label="$t('original.languages556')" :formatter="(row)=>row.isActive==1? $t('original.languages557') :$t('original.languages558')"></el-table-column>

            <el-table-column prop="createddate" sortable :label="$t('original.languages217')"></el-table-column>

            <el-table-column :label="$t('original.languages42')">
                <template v-slot="scope">
                    <div class="handle">

                        <el-button type="text" @click="$router.push('Addconditions?conditionID='+scope.row.conditionid)" style="margin:0 5px;">{{$t('original.languages57')}}</el-button>

                        <el-popconfirm :title="$t('original.languages559')" @confirm="confirmDetail(scope.row)">

                        <el-button type="text" slot="reference">{{$t('original.delete')}}</el-button>

                        </el-popconfirm>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination
                @current-change="handleCurrentChange"
                hide-on-single-page
                :current-page.sync="params.pageIndex"
                :page-size="params.pageSize"
                layout="total, prev, pager, next"
                :total="params.Total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default{
    name:'comprehensiveconditions',
    data() {
        return {
            loading:true,
            params:{
                pageIndex:1,
                pageSize:10,
                Total:0,
                condition:''
            },
            comprehensiveData:[]
        }
    },
    created() {
        this.getpaperconditionlist();
    },
    methods: {
        handleCurrentChange(val){
            this.params.pageIndex=val;
            this.loading=true;
            this.getpaperconditionlist();
        },

        // 获取列表
        getpaperconditionlist(){
            this.$Http_Post('querypaper/getpaperconditionlist',this.params).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.params.Total=res.Counts;
                    this.comprehensiveData=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        search(){
            this.params.pageIndex=1;
            this.getpaperconditionlist();
        },
        // 重置
        reset(){
            this.params=this.$options.data().params;
            this.getpaperconditionlist();
        },
        // 删除记录
        confirmDetail(val){
            this.$Http_Post('querypaper/delpapercondition',{conditionID:val.conditionid}).then(res=>{
                if(res.Code==0){
                    this.getpaperconditionlist();
                    this.$message({type: 'success', message:res.Message});
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        confirmedit(){
            this.$Http_Post('querypaper/updatepapercondition',this.editparams).then(res=>{
                if(res.Code==0){
                    this.getpaperconditionlist();
                    this.editdrawer=false;
                    this.$message({type: 'success', message:res.Message});
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        }
    },
}
</script>
<style>
.comprehensiveconditions .header{background: #fff;padding: 20px;}
.comprehensiveconditions .header .item{display:inline-block;margin-right: 30px;}
.comprehensiveconditions .Main{margin: 20px 0;background: #fff;padding:20px;}
.comprehensiveconditions .condition{width: 260px;}
.comprehensiveconditions .condition .el-textarea__inner{min-height:260px!important;}
</style>